export const registerEs = {
  "pos.recovery.others.title": "Pagos de otros operadores",
  "pos.recovery.others.help": "Una cuenta con un pago abierto no se puede cargar. Revise la caja y luego confirme el pago registrado o retire el que nunca se cobró. Solo el operador puede completarlo, así que aquí no se cobra nada.",
  "pos.recovery.others.empty": "Ningún otro operador tiene un pago abierto.",
  "pos.recovery.others.operator": "Preparado por",
  "pos.recovery.others.resolve": "Confirmar el resultado registrado",
  "pos.correction.title": "Corregir este cargo",
  "pos.correction.subtitle": "Nada cambia en la venta ni en un día cerrado. Se registra un asiento de corrección hoy, en el período abierto.",
  "pos.correction.charged": "Cargado a",
  "pos.correction.left": "Queda en este cargo",
  "pos.correction.tipLeft": "Propina restante",
  "pos.correction.kind": "Qué hay que corregir",
  "pos.correction.kind.void": "Anular todo el cargo",
  "pos.correction.kind.partial": "Devolver una parte",
  "pos.correction.kind.move": "Pasarlo al socio correcto",
  "pos.correction.quantityHelp": "Indique la cantidad a devolver. El impuesto y el cargo por servicio siguen exactamente cada línea.",
  "pos.correction.quantity": "Cantidad a devolver",
  "pos.correction.available": "Queda",
  "pos.correction.tip": "Propina a devolver",
  "pos.correction.moveTo": "Socio al que corresponde el cargo",
  "pos.correction.moveToChosen": "Pasa a {name}",
  "pos.correction.change": "Elegir otro socio",
  "pos.correction.restock": "La mercancía volvió al inventario",
  "pos.correction.restockHint": "Déjelo sin marcar para lo que se sirvió o se usó.",
  "pos.correction.reason": "Motivo",
  "pos.correction.reviewAgain": "Revisar de nuevo",
  "pos.correction.review": "Revisar la corrección",
  "pos.correction.invalid": "Elija qué corregir e indique un motivo de al menos 3 caracteres.",
  "pos.correction.reviewTitle": "Revise antes de registrar",
  "pos.correction.items": "Artículos",
  "pos.correction.service": "Cargo por servicio",
  "pos.correction.tax": "Impuesto",
  "pos.correction.gratuity": "Propina",
  "pos.correction.total": "Total acreditado",
  "pos.correction.totalMoved": "Total trasladado",
  "pos.correction.from": "De",
  "pos.correction.to": "A",
  "pos.correction.posts": "Se registra el {date}",
  "pos.correction.minimum": "El gasto mínimo cambia en el mes en que esto se registra ({date}), no en el mes de la venta. Un faltante ya facturado no se recalcula.",
  "pos.correction.paid": "Ya se pagaron {amount}. Se retiran del pago y quedan como crédito en la cuenta.",
  "pos.correction.statement": "Este cargo está en un estado de cuenta finalizado. Ese estado no cambia; la corrección aparece en el siguiente.",
  "pos.correction.returns": "Vuelve al inventario: {items}",
  "pos.correction.noStock": "El inventario no cambia.",
  "pos.correction.ack": "Revisé los importes y el socio",
  "pos.correction.confirm": "Registrar la corrección",
  "pos.correction.done": "Corrección registrada.",
  "pos.correction.history": "Correcciones de esta cuenta",
  "pos.correction.none": "Aún no hay correcciones.",
  "pos.correction.finished": "No queda nada por corregir en este cargo.",
  "pos.correction.blocked.pos_correction_unsupported": "Aquí solo se puede corregir una cuenta cargada a un socio.",
  "pos.correction.blocked.pos_correction_not_settled": "Esta cuenta no está liquidada, así que aún se puede cambiar en la propia cuenta.",
  "pos.correction.blocked.funding_correction_required": "Esta cuenta se pagó con fondos aplicados. Use su reembolso a la forma de pago original.",
  "pos.correction.blocked.payment_recovery_pending": "Hay un pago abierto en esta cuenta. Resuélvalo primero en Recuperación de pagos.",
  "pos.correction.dayTotal": "Correcciones de cargos a socios",
  "pos.correction.dayMoved": "Pasado a otro socio (sin cambio en las ventas)",
  "pos.register.resetLookup": "Restablecer filtros de cuentas",
  "pos.register.findChecks": "Buscar cuentas",
  "pos.register.businessDate": "Fecha operativa",
  "pos.register.allDates": "Todas las fechas operativas",
  "pos.register.searchChecks": "Buscar cuenta, mesa, socio o número de socio",
  "pos.register.refreshChecks": "Actualizar cuentas",
  "pos.register.clearSearch": "Borrar búsqueda",

  "pos.register.checkSettlement": "Comprobar estado del cobro",
  "pos.register.statusUnresolved": "El cobro no está confirmado. Conserve esta solicitud y reinténtela o solicite revisión de un responsable. Una cuenta abierta no demuestra que falló la solicitud anterior.",

  "pos.register.details": "Mesa y mesero",
  "pos.register.detailsHelp": "Cambie la mesa, los comensales o el mesero asignado. Las pantallas de cocina muestran la asignación actual; los pedidos originales se conservan y las impresoras reciben un aviso de actualización.",
  "pos.register.invalidDetails": "Use hasta 12 letras, números, espacios o guiones para la mesa y un número entero de comensales de 0 a 500.",
  "pos.register.reloadCheck": "Recargar cuenta actual",
  "pos.register.searchStaff": "Buscar personal",
  "pos.register.unassigned": "Sin asignar",
  "pos.register.currentServer": "Mesero actual",
  "pos.register.settlePendingCourses": "Cerrar esta cuenta envía todos los artículos pendientes, incluidos los tiempos posteriores y los retenidos manualmente. Revise el pedido antes de cobrar.",
  "pos.register.nextCourse": "Enviar siguiente: tiempo {course}",
  "pos.register.nextCourseEmpty": "Enviar siguiente tiempo",
  "pos.register.chooseCourse": "Enviar un tiempo…",
  "pos.register.courseHelp": "Seleccione un tiempo para enviar. Las líneas retenidas manualmente y los otros tiempos quedan pendientes.",
  "pos.register.sendAllCourses": "Enviar todos los tiempos sin retener",
  "pos.register.course": "Tiempo",
  "pos.register.courseNumber": "Tiempo {course}",
  "pos.register.fireCourse": "Enviar tiempo {course}",
  "pos.register.decrease": "Reducir {label}",
  "pos.register.increase": "Aumentar {label}",
  "pos.register.limit": "Límite de crédito: {amount}",
  "pos.register.wouldBe": "Saldo posterior al cargo: {amount}",
  "pos.register.overrideRequired": "Ingrese el motivo para esta excepción.",
  "pos.register.barcode": "Escanear código de barras o ingresar SKU",
  "pos.register.lookup": "Agregar artículo escaneado",
  "pos.register.unavailable":
    "Este artículo o variante no se vende en este punto de venta hoy.",
  "pos.register.title": "Caja de punto de venta",
  "pos.register.subtitle":
    "Abra una cuenta, tome un pedido y cobre desde una pantalla táctil.",
  "pos.register.outlet": "Punto de venta",
  "pos.register.chooseOutlet": "Elija un punto de venta",
  "pos.register.open": "Abiertas",
  "pos.register.settled": "Cobradas",
  "pos.register.voided": "Anuladas",
  "pos.register.mine": "Solo mis cuentas",
  "pos.register.new": "Nueva cuenta",
  "pos.register.table": "Mesa / referencia",
  "pos.register.searchOrScan": "Buscar o escanear",
  "pos.register.quickCharge": "Cargar {amount} a {name}",
  "pos.register.lineActions": "Acciones para {line}",
  "pos.register.ringForMember": "Cobrar a un socio",
  "pos.register.covers": "Comensales",
  "pos.register.coverCount_one": "{count} comensal",
  "pos.register.coverCount_other": "{count} comensales",
  "pos.register.tenderChosen": "Forma de pago: {tender}",
  "pos.register.empty": "No hay cuentas abiertas",
  "pos.register.noMatches": "Ninguna cuenta coincide con estos filtros",
  "pos.register.check": "Cuenta {number}",
  "pos.register.lines": "{count} artículos",
  "pos.register.menu": "Menú",
  "pos.register.all": "Todas las categorías",
  "pos.register.search": "Buscar en el menú",
  "pos.register.send": "Enviar pedido",
  "pos.register.sentCount": "Se enviaron {count} artículos",
  "pos.register.held": "Retenido",
  "pos.register.sent": "Enviado",
  "pos.register.comped": "Cortesía",
  "pos.register.pending": "Pendiente",
  "pos.register.seat": "Asiento",
  "pos.register.quantity": "Cantidad",
  "pos.register.note": "Nota para cocina",
  "pos.register.hold": "Retener para cocina",
  "pos.register.add": "Agregar a la cuenta",
  "pos.register.choices": "Elija opciones",
  "pos.register.variant": "Variante",
  "pos.register.selection": "Elija al menos {min}; máximo {max}",
  "pos.register.any": "sin límite",
  "pos.register.invalidChoices":
    "Complete las opciones obligatorias y revise las cantidades.",
  "pos.register.move": "Cambiar de asiento",
  "pos.register.edit": "Editar artículo",
  "pos.register.voidLine": "Anular artículo",
  "pos.register.compLine": "Artículo de cortesía",
  "pos.register.voidCheck": "Anular cuenta",
  "pos.register.reason": "Motivo",
  "pos.register.chooseReason": "Elija un motivo",
  "pos.register.noReasons":
    "No hay motivos activos. Un gerente debe configurarlos primero.",
  "pos.register.approval": "Se requiere aprobación del gerente",
  "pos.register.managerEmail": "Correo del gerente",
  "pos.register.managerPassword": "Contraseña del gerente",
  "pos.register.approve": "Aprobar y continuar",
  "pos.register.attach": "Vincular socio",
  "pos.register.memberSearch": "Buscar socio por número o nombre",
  "pos.register.typeMember": "Escriba un número o nombre",
  "pos.register.noMembers": "No hay coincidencias",
  "pos.register.account": "Cuenta {number} · {status}",
  "pos.register.balance": "Saldo: {amount}",
  "pos.register.available": "Crédito disponible: {amount}",
  "pos.register.noLimit": "Sin límite",
  "pos.register.selectMember": "Elegir a {name}",
  "pos.register.photo": "Foto del socio",
  "pos.register.settle": "Cobrar cuenta",
  "pos.register.member_charge": "Cargo al socio",
  "pos.register.room_charge": "Cargo a habitación",
  "pos.register.no_charge": "Sin cargo",
  "pos.register.room": "Habitación / cabaña",
  "pos.register.gratuity": "Propina",
  "pos.register.paper": "Comprobante firmado en papel",
  "pos.register.preview": "Revisar cargo",
  "pos.register.charge": "Cobrar {amount}",
  "pos.register.previewTotal": "Total final: {amount}",
  "pos.register.after": "Saldo posterior: {amount}",
  "pos.register.override": "Anular restricción de crédito/cuenta",
  "pos.register.overrideReason": "Motivo de anulación de restricción",
  "pos.register.changed":
    "El total cambió. Revise el importe actualizado antes de cobrar de nuevo.",
  "pos.register.moneyInvalid":
    "Ingrese un importe no negativo con un máximo de dos decimales.",
  "pos.register.receipt": "Recibo",
  "pos.register.print": "Imprimir recibo",
  "pos.register.back": "Volver a caja",
  "pos.register.subtotal": "Subtotal",
  "pos.register.service": "Cargo de servicio",
  "pos.register.discount": "Descuento",
  "pos.register.total": "Total",
  "pos.register.signature": "Firma",
  "pos.register.noMenu": "No hay artículos disponibles en este punto de venta.",
  "pos.register.emptyCheck": "Elija un artículo para iniciar el pedido.",
  "pos.register.date": "Fecha operativa",
  "pos.register.dayClose": "Cierre del día",
  "pos.register.closeDay": "Cerrar el día",
  "pos.register.openBlocksClose":
    "Cobre o anule las cuentas abiertas antes de cerrar.",
  "pos.register.closed": "Día cerrado",
  "pos.register.checksSettled": "Cuentas cobradas: {count}",
  "pos.register.checksVoided": "Cuentas anuladas: {count}",
  "pos.register.reasons": "Motivos de anulación y cortesía",
  "pos.register.code": "Código",
  "pos.register.name": "Nombre",
  "pos.register.kind": "Tipo",
  "pos.register.void": "Anulación",
  "pos.register.comp": "Cortesía",
  "pos.register.both": "Anulación y cortesía",
  "pos.register.needsApproval": "Requiere aprobación del gerente",
  "pos.register.active": "Activo",
  "pos.register.newReason": "Nuevo motivo",
  "pos.register.saved": "Guardado",
  "pos.register.settleNeedsMember": "Elija un socio autorizado para firmar.",
  "pos.register.settleNeedsRoom": "Elija una habitación o cabaña.",
  "pos.register.allChecks": "Cuentas",
  "pos.register.retry": "Reintentar",
  "pos.register.cancelRetry": "Descartar reintento pendiente",
  "pos.register.retryNotice":
    "Una solicitud tiene un resultado incierto. Reinténtela con el mismo identificador antes de agregar otro artículo.",
  "pos.register.server": "Mesero",
  "pos.nav.register": "Caja",
  "pos.nav.dayClose": "Cierre del día",
  "pos.nav.reasons": "Motivos",
  "pos.register.searchHint": "Busque nombres, variantes, SKU o códigos de barras.",
  "pos.register.priceFrom": "Desde {price}",
  "pos.register.noMenuMatches": "Ningún artículo coincide con esta búsqueda y categoría.",
  "pos.register.clearMenuFilters": "Borrar filtros del menú",
  "pos.move.title": "Dividir / mover artículos",
  "pos.move.help": "Mueva cantidades seleccionadas, artículos completos o un asiento a una cuenta nueva o existente. Se conservan precios, cortesías e historial original de cocina. La comida enviada no se prepara de nuevo.",
  "pos.move.portion": "Porción dividida",
  "pos.move.quantity": "Cantidad a mover · {item}",
  "pos.move.quantityInvalid": "Introduzca una cantidad positiva con hasta tres decimales que no supere la cantidad de cada artículo seleccionado.",
  "pos.move.remaining": "{quantity} permanece en la cuenta original",
  "pos.move.invalid": "Seleccione entre 1 y 500 artículos e introduzca una mesa y un número de comensales válidos.",
  "pos.move.destinationUnavailable": "Elija una cuenta de destino abierta y espere sus datos.",
  "pos.move.retry": "Reintentar el mismo traslado",
  "pos.move.confirm": "Confirmar traslado",
  "pos.move.preview": "Vista previa del traslado",
  "pos.move.uncertain": "El resultado es incierto. Reintente el mismo traslado antes de hacer otra solicitud. No puede aplicarse dos veces.",
  "pos.move.reviewDestination": "Destino",
  "pos.move.newCheck": "Nueva cuenta dividida",
  "pos.move.sourceAfter": "Total de origen después del traslado",
  "pos.move.targetAfter": "Total de destino después del traslado",
  "pos.move.totalChange": "Cambio del total combinado",
  "pos.move.roundingHelp": "Separar cantidades o combinar cuentas puede cambiar el redondeo de precios, descuentos e impuestos. Son totales estándar; las exenciones del pagador y las propinas se revisan al cobrar.",
  "pos.move.mergesSource": "Se moverán todos los artículos vigentes. La cuenta de origen se cerrará como combinada y enlazará al destino. No se anula comida ni se registra un pago.",
  "pos.move.edit": "Editar selección",
  "pos.move.selectBySeat": "Seleccionar artículos por asiento",
  "pos.move.all": "Todos los artículos vigentes",
  "pos.move.destination": "Cuenta de destino",
  "pos.move.newCovers": "Comensales de la nueva cuenta",
  "pos.move.openDestination": "Esta cuenta se combinó — abrir destino",
  "pos.move.sourceBefore": "Total de origen antes del traslado",
  "pos.move.targetBefore": "Total de destino antes del traslado",
  "pos.register.merged": "Combinada",
};
